import React from 'react';
import styles from './styles.module.css';
import parts from '../moduleCard/moduleParts.module.css';
import { IconButton, ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CenterFocusWeakOutlinedIcon from '@mui/icons-material/CenterFocusWeakOutlined';
import { DEFAULT_TRANSFORM, MAX_SCALE, MIN_SCALE, zoomTransform } from './ZoomableImage';

export const COMPARE_MODES = Object.freeze({ SIDE: 'side', SLIDER: 'slider' });

/**
 * Controles do comparador, usados no card e no modo apresentação: modo (lado a
 * lado / deslizante) e barra de zoom. `compatible` diz se o deslizante está
 * disponível; `hasPair` se há duas fotos (muda a dica do botão desativado).
 * `children` entram à direita (ex.: botão de tela cheia).
 */
const EvolutionCompareControls = ({ mode, compatible, hasPair, onMode, transform, onTransform, children }) => (
  <div className={styles.compareControls}>
    <ToggleButtonGroup
      size="small"
      exclusive
      value={mode}
      onChange={(event, value) => value && onMode(value)}
    >
      <ToggleButton value={COMPARE_MODES.SIDE} className={parts.toggleButton}>Lado a lado</ToggleButton>
      <Tooltip title={compatible ? '' : (hasPair ? 'Só para fotos da mesma região e ângulo' : 'Precisa de duas fotos')}>
        <span>
          <ToggleButton value={COMPARE_MODES.SLIDER} className={parts.toggleButton} disabled={!compatible}>
            Deslizante
          </ToggleButton>
        </span>
      </Tooltip>
    </ToggleButtonGroup>

    <div className={styles.zoomBar} aria-label="Zoom">
      <IconButton size="small" onClick={() => onTransform((current) => zoomTransform(current, 1 / 1.25))} disabled={transform.scale <= MIN_SCALE} aria-label="Afastar">
        <RemoveIcon fontSize="small" />
      </IconButton>
      <span className={styles.zoomValue}>{`${Math.round(transform.scale * 100)}%`}</span>
      <IconButton size="small" onClick={() => onTransform((current) => zoomTransform(current, 1.25))} disabled={transform.scale >= MAX_SCALE} aria-label="Aproximar">
        <AddIcon fontSize="small" />
      </IconButton>
      <IconButton size="small" onClick={() => onTransform(DEFAULT_TRANSFORM)} disabled={transform === DEFAULT_TRANSFORM} aria-label="Centralizar">
        <CenterFocusWeakOutlinedIcon fontSize="small" />
      </IconButton>
    </div>

    {children}
  </div>
);

export default EvolutionCompareControls;
